<p class="error"><span  *ngIf="error">{{error}}</span></p>
<ion-list id="user-info-container">
  <ion-item>
    <label class="ion-text-right">{{ 'USER_INFO.EMAIL' | translate }}</label><p>{{email}}</p>
  </ion-item>
  <!-- Language selector as a form field -->
  <ion-item class="language-item" button (click)="openLanguageSwitcher()" *ngIf="isToggleEnabled('internationalization')">
    <ion-label>{{ 'USER_INFO.LANGUAGE' | translate }}</ion-label>
    <div slot="end" class="language-display">
      <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
      <span class="language-name">{{ currentLanguageInfo.name }}</span>
      <ion-icon *ngIf="editing" name="chevron-forward" color="medium"></ion-icon>
    </div>
  </ion-item>
  <ion-item>
    <ion-button *ngIf="!editing" (click)="startEditing()" fill="solid" color="primary">{{ 'USER_INFO.EDIT' | translate }}</ion-button>
    <div *ngIf="editing" class="edit-buttons">
      <ion-button (click)="saveChanges()" fill="solid" color="success">{{ 'USER_INFO.SAVE' | translate }}</ion-button>
      <ion-button (click)="cancelEditing()" fill="outline" color="medium">{{ 'USER_INFO.CANCEL' | translate }}</ion-button>
    </div>
  </ion-item>
  
  <ion-item>
    <ion-button (click)="deleteAccount()" color="danger">{{ 'USER_INFO.DELETE_ACCOUNT' | translate }}</ion-button>
  </ion-item>

  <ion-item class="premium-upgrade" *ngIf="trialAvailable()">
    <p>{{ 'USER_INFO.PREMIUM_FEATURES_AVAILABLE' | translate }}</p>
    <ion-button (click)="startTrial()">{{ 'USER_INFO.START_TRIAL' | translate }}</ion-button>
  </ion-item>
</ion-list>
